import { createSlice } from '@reduxjs/toolkit';
import initialState from './tinyUrl.initialState';
import { createTinyUrl, fetchUrls } from './tinyUrl.actions';

export const tinyUrlSlice = createSlice({
  name: 'tinyUrlSlice',
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchUrls.pending, (state) => {
        state.urls.loading = true;
        state.urls.error = null;
      })
      .addCase(fetchUrls.rejected, (state, action) => {
        state.urls.loading = false;
        state.urls.error = action.payload;
      })
      .addCase(fetchUrls.fulfilled, (state, action) => {
        const { urls, total } = action.payload;
        state.urls.data = urls;
        state.urls.total = total;
        state.urls.loading = false;
        state.urls.error = null;
      })
      .addCase(createTinyUrl.pending, (state) => {
        state.createTinyUrl.loading = true;
        state.createTinyUrl.error = null;
      })
      .addCase(createTinyUrl.rejected, (state, action) => {
        state.createTinyUrl.loading = false;
        state.createTinyUrl.error = action.payload;
        state.createTinyUrl.data = '';
      })
      .addCase(createTinyUrl.fulfilled, (state, action) => {
        state.createTinyUrl.data = action.payload;
        state.createTinyUrl.loading = false;
        state.createTinyUrl.error = null;
      });
  },
});
